import {KTIcon} from '../../../../_metronic/helpers'

const WalletConfigModalHeader = ({setOpenWalletConfigModal}) => {
  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>Wallet Configuration</h2>
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() =>  {
          setOpenWalletConfigModal(false)
        }}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>

    </div>
  )
}

export {WalletConfigModalHeader}
